import { useAtomValue } from "jotai/index";
import { headerActiveButtonAtom } from "@/interface/AppStore";
import { PresentationsWindow } from "@/interface/RightSheet/Presentations";
import styles from "./RightSheet.module.scss";

export const RightSheet = () => {
    const activeButtonName = useAtomValue(headerActiveButtonAtom);
    if (activeButtonName !== "presentation") {
        return null;
    }

    return (
        <div className={styles.rightSheet}>
            <div className={styles.rightSheetInner}>
                <PresentationsWindow />
            </div>
        </div>
    );
};
